<template>
  <div id="app">
    <Header @childByValue="childByValue" v-if="$route.path !== 'nsrxt'"></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
    <!-- <Piao @changeOpen="changeOpen" v-if='show' :img="tip" :direction="direction"/>
    <Piao @changeOpen="changeOpen1" v-if='show1' :img="tip2" :direction="direction1"/> -->
  </div>
</template>

<script>
// import Piao from './components/piao.vue'
export default {
  name: 'App',
  // components: { Piao },
  data () {
    return {
      // show: true,
      // show1: true,
      // tip: 'https://ruiyoo-cdn-image.oss-cn-shenzhen.aliyuncs.com/website/ruiyooImage/tip.jpg',
      // tip2: 'https://ruiyoo-cdn-image.oss-cn-shenzhen.aliyuncs.com/website/ruiyooImage/tip2.jpg',
      // direction: 'left',
      // direction1: 'right'
    }
  },
  created () {
    // if (this._isMobile()) {
    //   this.show = false,
    //   this.show1 = false
    // }
  },
  methods: {
    // _isMobile() {
    //   let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    //   return flag;
    // },
    childByValue(childValue) {
      window.scrollTo(100, childValue);
    },
    // changeOpen () {
    //   this.show = false
    // },
    // changeOpen1 () {
    //   this.show1 = false
    // }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue